import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

import { AuthService } from '../_services/auth.service'
import { environment } from '../../environments/environment';

@Injectable()
export class PromotionService {
  url: any = environment.va_service_api + 'promotions/';

  constructor(private _http: HttpClient, private _auth: AuthService) { }

  createPromotion(agentId, params) {
    let _url = this.url + agentId
    return this._http.post(_url, params)
  }

  getAllPromotions(agentId) {
    return this._http.get(this.url + agentId)
  }

  deletePrmotion(agentId, promotionId){
    return this._http.delete(this.url + agentId +'/' + promotionId)
  }

  updatePromotion(agentId, promotionId, params){
    let _url = this.url + agentId + '/' + promotionId
    return this._http.put(_url, params)
  }

  changeSwitch(agentId, promotionId, params){
    let _url = this.url + agentId + '/' + promotionId
    return this._http.patch(_url, params)
  }

  getPromotionDetail(agentId, promotionId){
    return this._http.get(this.url + agentId + '/' + promotionId)
  }

  getContactInfo(agentId, topicURI) {
    return this._http.get(this.url + agentId + "/get_banner/" + topicURI)
  }

}
